export class PhotographerDashboardResume {
	draft: number = 0;
	readyForPickup: number = 0;
	inProgress: number = 0;
	shootCompleted: number = 0;
	approved: number = 0;
	rejected: number = 0;

	constructor(init?: Partial<PhotographerDashboardResume>) {
		Object.assign(this, init);
	}
}
